import { render, staticRenderFns } from "./good.vue?vue&type=template&id=20ee8807&scoped=true"
import script from "./good.vue?vue&type=script&lang=js"
export * from "./good.vue?vue&type=script&lang=js"
import style0 from "./good.vue?vue&type=style&index=0&id=20ee8807&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ee8807",
  null
  
)

export default component.exports